module.exports = __webpack_public_path__ + "img/icon8.ad928d51.png";